import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Container, Form, Grid, Header, Segment } from 'semantic-ui-react';
import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';

import '../css/LTIPlayerLauncher.less';

import { VIEW_SELECTION } from '../managers/NavigationManager';

import { setSessionStorageItem } from '../utils/session';

import Auth from '../managers/AuthManager';

import AuthCallbackService, { AUTH_CALLBACK_SESSION_KEY } from '../services/AuthCallbackService';

/**
 * AuthCallbackHandlerView
 *
 * Route handler at /authcallback. Receives a deep link with
 * `?callbackUrl=...`, stashes the URL in sessionStorage under `c2c_callbackUrl`,
 * and redirects to /signin if not yet authenticated.
 *
 * If already authenticated, clears the session key and forwards the user to
 * callbackUrl with authKey appended. After a fresh login, InitService reads
 * the session key and performs the same redirect.
 */
export default
@inject('navigationManager')
@observer
class AuthCallbackHandlerView extends Component {
  constructor(props) {
    super(props);
    this.state = { errorMessage: null, errorTitle: null };
    this.Logo = SatCoreComponent('Logo');
  }

  async componentDidMount() {
    const { history, location, navigationManager } = this.props;
    navigationManager.setView(VIEW_SELECTION.LOGIN);

    const urlParams = new URLSearchParams(location.search);
    let callbackUrl = null;
    let error = '';

    if (urlParams.has('error') && urlParams.get('error') !== 'null') {
      error = urlParams.get('error');
    }

    if (urlParams.has('callbackUrl') && urlParams.get('callbackUrl') !== 'null') {
      callbackUrl = urlParams.get('callbackUrl');
    }

    if (error) {
      this.verificationError('Error', error);
    } else if (callbackUrl) {
      // TODO: validate callbackUrl against an allowlist of trusted hosts before storing/redirecting
      try {
        setSessionStorageItem(AUTH_CALLBACK_SESSION_KEY, callbackUrl);
        console.info('[AuthCallback] Saved c2c_callbackUrl to sessionStorage');
      } catch (storageError) {
        console.error(storageError);
        this.verificationError('Error', 'Not Authorized');
        return;
      }

      if (Auth.loggedIn() && Auth.authKey) {
        const redirected = AuthCallbackService.redirectToCallbackUrlWithAuthKey(callbackUrl);
        if (!redirected) {
          this.verificationError('Error', 'Not Authorized');
        }
      } else {
        history.replace('/signin');
      }
    } else {
      this.verificationError('Error', 'Not Authorized');
    }
  }

  failPanel = () => {
    const { errorTitle, errorMessage } = this.state;
    const { Logo } = this;
    return (
      <Grid className='fullHeight' textAlign='center' verticalAlign='middle'>
        <Grid.Column className='max-width-558'>
          <Form>
            <Header as='h2' attached='top' block>
              <div className='message-header'>
                <Logo />
                <div>{errorTitle}</div>
              </div>
            </Header>
            <Segment attached>
              <Form.Field>
                <Container className='login-error-message' text>
                  {errorMessage}
                </Container>
              </Form.Field>
            </Segment>
          </Form>
        </Grid.Column>
      </Grid>
    );
  }

  verificationError = (errorTitle, errorMessage) => {
    this.setState({ errorMessage, errorTitle });
  }

  render() {
    const { errorMessage } = this.state;
    if (errorMessage) {
      return (
        <div className='lrn-player-launcher-container student-assignment-launcher-container'>
          {this.failPanel()}
        </div>
      );
    }
    return null;
  }
}

SatCoreRegister('AuthCallbackHandlerView', AuthCallbackHandlerView);
